import api from '@/api/api_login'
import Vue from 'vue'
import { asyncLoading } from 'vuejs-loading-plugin'
import VueLoading from 'vuejs-loading-plugin'


Vue.use(VueLoading, {
    dark: true, // default false
    text: 'Carregando', // default 'Loading'
    loading: false, // default false
    background: 'rgba(10,23,55,0.7)', // set custom background
})

export default {
  CLIENTINFO({ commit }, {ip}) {
    return new Promise(async (resolve, reject) =>{
      try {
        const info = await api.clientinfo(ip)
        commit('CLIENTINFO', info )
        resolve(info)
      } catch (error) {
        reject(error)
        
      }
    })
  },
  LOGIN({ commit }, {user, clientinfo}) {
    let loading = new Promise(async (resolve, reject) => {
      try {
        const info = await api.login(user, clientinfo)
        commit('LOGIN', info )
        resolve(info)
      } catch(error) {
        reject(error)
      }
    })
    return asyncLoading(Promise.resolve(loading)).then().catch()
  },
}